import type { JSX } from "react";

import { Input } from "@frontend/components/atoms/Input";
import { useLingui } from "@lingui/react/macro";

import { useAddressText } from "../hooks/useAddressText";
import type { AddressFieldProps } from "../types";
import { FieldFrame } from "./FieldFrame";

/**
 * The postal code. It is filled in by the commune and the street, so a form
 * that trusts the referential locks it rather than letting the two disagree.
 */
export function PostalCodeField({
  field,
  label,
  placeholder,
  size,
  disabled,
}: AddressFieldProps): JSX.Element {
  const { t } = useLingui();

  const { value, setValue, error } = useAddressText(field);

  return (
    <FieldFrame label={label} error={error}>
      <Input
        value={value}
        placeholder={placeholder ?? t`Postal code`}
        size={size}
        disabled={disabled}
        invalid={Boolean(error)}
        onValueChange={setValue}
      />
    </FieldFrame>
  );
}
